import type { PropsWithChildren } from 'react';

export type CalloutType = 'info' | 'tip' | 'warning' | 'important' | 'concept';

const LABEL: Record<CalloutType, string> = {
  info: 'Informação',
  tip: 'Dica',
  warning: 'Atenção',
  important: 'Importante',
  concept: 'Entenda o conceito',
};

export function Callout({ type = 'info', children }: PropsWithChildren<{ type?: CalloutType }>) {
  return (
    <aside className={`callout callout-${type}`}>
      <strong className="callout-label">{LABEL[type]}</strong>
      <div className="callout-content">{children}</div>
    </aside>
  );
}
